import type { FaireProductEntity } from "../../entity_types/product";

export const p_v8xjxfa8pj: FaireProductEntity = {
  token: "p_v8xjxfa8pj",
  type: "product",
  name: "Lizzie You Rock, Don't Ever Change - Retro Y2k Pop Culture Card",
  brandToken: "b_104phd1wp3",
  brandName: "Simple Whimsy",
  imageUrl:
    "https://cdn.faire.com/fastly/30f56c6844a0d0e4ea11d9e4e4ebc12254eec1b4d0ed1c3d4c073c214fd6440b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcdb50331512838751f38b4257bf8a833e110f2b9471d2f7c2d1e7a76619fcdc.jpeg",
    "https://cdn.faire.com/fastly/f6940313c83d899705976de25d360d966110e415eb4d1206c200c9ecc7cd639d.png",
  ],
  priceDollars: 2.75,
  description:
    '- A2 size: 4.25" x 5.5" \n- Printed on thick, premium matte card stock\n- Blank inside\n- Original hand illustration by Sam, No AI! \n- Printed in Canada\n- Paired with a kraft envelope and packaged in a cellophane sleeve\n\n',
  tags: [],
  msrpDollars: 5.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:06.334Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
